import { render, staticRenderFns } from "./_joker.vue?vue&type=template&id=04a6f3fc&lang=pug&"
import script from "./_joker.vue?vue&type=script&lang=js&"
export * from "./_joker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports